var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTx1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_677_2644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1597 19.2298L12.9476 19.2364L12.8594 19.1391C12.8594 17.2319 12.8607 15.3247 12.8635 13.4175C12.8635 12.8936 12.9027 12.8535 13.4176 12.8535C15.1611 12.8535 16.9045 12.8535 18.6489 12.8576C18.8221 12.8722 18.994 12.9018 19.1621 12.9459L19.1492 12.9328C19.1908 13.0148 19.2197 13.1028 19.2349 13.1935C19.2349 15.1912 19.2292 17.1892 19.2178 19.1874C19.1994 19.203 19.1801 19.217 19.1597 19.2298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72741 12.9353C8.80295 12.9353 7.87767 12.9279 6.95322 12.941C6.66877 12.9451 6.5625 12.8258 6.5625 12.5634C6.5625 10.6861 6.5625 8.80914 6.5625 6.93244C6.5625 6.58423 6.81344 6.5597 7.07255 6.5597H10.9085C11.439 6.5597 11.9711 6.56706 12.5 6.5597C12.8073 6.55481 12.9413 6.68478 12.9405 6.99537C12.9356 8.859 12.9356 10.7226 12.9405 12.5863C12.9405 12.8527 12.8465 12.9443 12.5825 12.941C11.6303 12.9287 10.6797 12.9353 9.72741 12.9353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1564 12.9464C19.1155 12.7106 19.0883 12.4726 19.0747 12.2337C19.0673 10.5466 19.0707 8.85949 19.0747 7.17324C19.0747 6.65911 19.1703 6.56348 19.691 6.56348C21.419 6.56348 23.1467 6.56348 24.874 6.56348C25.3931 6.56348 25.4593 6.63213 25.4593 7.1528C25.4593 8.93469 25.4535 10.7166 25.4641 12.4993C25.4641 12.8262 25.3563 12.9668 25.0211 12.9636C23.0595 12.948 21.1043 12.9423 19.1459 12.9341L19.1564 12.9464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8613 19.1387L12.9561 19.2336C12.9529 21.1408 12.9499 23.048 12.9472 24.9552C12.9472 25.4456 12.8728 25.5273 12.3864 25.5273C10.6427 25.5273 8.89895 25.5273 7.15519 25.5273C6.64434 25.5273 6.57077 25.4456 6.57077 24.9404C6.57077 23.1832 6.58139 21.4257 6.56259 19.6692C6.5585 19.2604 6.68683 19.1363 7.09962 19.1403C9.01963 19.1542 10.9372 19.1403 12.8613 19.1387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.162 19.2295C19.1804 19.2175 19.1982 19.2044 19.2151 19.1903C19.3346 19.1709 19.4553 19.1581 19.5764 19.1519C21.3876 19.1519 23.1998 19.1575 25.0111 19.1436C25.3462 19.1436 25.4663 19.2384 25.4639 19.581C25.4526 21.4064 25.4526 23.2319 25.4639 25.0573C25.4639 25.4154 25.3151 25.5324 24.9735 25.5306C23.1884 25.5224 21.4038 25.5224 19.6196 25.5306C19.2551 25.5306 19.0687 25.3925 19.0703 25.0116C19.0745 23.1994 19.0703 21.3874 19.0761 19.576C19.091 19.4575 19.1198 19.3412 19.162 19.2295Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_677_2644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTx1);
export default __webpack_public_path__ + "static/media/tx1.d52d862b2c74547f1b3aa45fe45d0c39.svg";
export { ForwardRef as ReactComponent };